module.exports = __webpack_public_path__ + "static/img/independently-audited@2x.b4e2ae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img-text/images/independently-audited@2x.png
// module id = o34E
// module chunks = 26